import { useSearchParams } from "react-router-dom";
import { AuthTemplate } from "../../components/auth-template/auth-template.comp";
import "../auth/signin/style.scss";

const AuthValidationError = () => {
    const [searchParams] = useSearchParams();
    const message = searchParams.get("message") || "Invalid authentication request";

    return (
        <AuthTemplate>
            <div className="signin">
                <div className="signin-title">Authentication Error</div>
                <div className="signin-content">
                    <div
                        style={{
                            padding: "30px 20px",
                            textAlign: "center",
                            color: "#d32f2f"
                        }}
                    >
                        <div style={{ marginBottom: "20px", fontSize: "16px", fontWeight: 500 }}>
                            {message}
                        </div>
                        <div style={{ fontSize: "14px", color: "#666", lineHeight: "1.6" }}>
                            Please ensure you navigate to the authentication page from your tenant
                            domain.
                            <br />
                            <br />
                            If you continue to experience issues, please contact support.
                        </div>
                    </div>
                </div>
            </div>
        </AuthTemplate>
    );
};

export default AuthValidationError;
